"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowScroll = exports.useWindowSize = exports.useIsPrinting = exports.useLocalStorage = exports.setLocalStorageItem = exports.getLocalStorageItem = exports.useBodyScrollDisable = exports.useDeviceDetect = exports.useDebounce = exports.useOnClickOutside = exports.clearCookies = exports.useCookie = exports.setCookieItem = exports.getCookieItem = exports.useDebouncerPlus = exports.useCheckValueInterval = void 0;

var useCheckValueInterval_1 = require("./useCheckValueInterval");

Object.defineProperty(exports, "useCheckValueInterval", {
  enumerable: true,
  get: function get() {
    return __importDefault(useCheckValueInterval_1).default;
  }
});

var useDebouncerPlus_1 = require("./useDebouncerPlus");

Object.defineProperty(exports, "useDebouncerPlus", {
  enumerable: true,
  get: function get() {
    return __importDefault(useDebouncerPlus_1).default;
  }
});

var useCookie_1 = require("./useCookie");

Object.defineProperty(exports, "getCookieItem", {
  enumerable: true,
  get: function get() {
    return useCookie_1.getCookieItem;
  }
});
Object.defineProperty(exports, "setCookieItem", {
  enumerable: true,
  get: function get() {
    return useCookie_1.setCookieItem;
  }
});
Object.defineProperty(exports, "useCookie", {
  enumerable: true,
  get: function get() {
    return useCookie_1.useCookie;
  }
});
Object.defineProperty(exports, "clearCookies", {
  enumerable: true,
  get: function get() {
    return useCookie_1.clearCookies;
  }
});

var useClickOutside_1 = require("./useClickOutside");

Object.defineProperty(exports, "useOnClickOutside", {
  enumerable: true,
  get: function get() {
    return __importDefault(useClickOutside_1).default;
  }
});

var useDebounce_1 = require("./useDebounce");

Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return __importDefault(useDebounce_1).default;
  }
});

var useDeviceDetect_1 = require("./useDeviceDetect");

Object.defineProperty(exports, "useDeviceDetect", {
  enumerable: true,
  get: function get() {
    return useDeviceDetect_1.useDeviceDetect;
  }
});

var useBodyScrollDisable_1 = require("./useBodyScrollDisable");

Object.defineProperty(exports, "useBodyScrollDisable", {
  enumerable: true,
  get: function get() {
    return __importDefault(useBodyScrollDisable_1).default;
  }
});

var useLocalStorage_1 = require("./useLocalStorage");

Object.defineProperty(exports, "getLocalStorageItem", {
  enumerable: true,
  get: function get() {
    return useLocalStorage_1.getLocalStorageItem;
  }
});
Object.defineProperty(exports, "setLocalStorageItem", {
  enumerable: true,
  get: function get() {
    return useLocalStorage_1.setLocalStorageItem;
  }
});
Object.defineProperty(exports, "useLocalStorage", {
  enumerable: true,
  get: function get() {
    return useLocalStorage_1.useLocalStorage;
  }
});

var usePrinting_1 = require("./usePrinting");

Object.defineProperty(exports, "useIsPrinting", {
  enumerable: true,
  get: function get() {
    return usePrinting_1.useIsPrinting;
  }
});

var useWindowResize_1 = require("./useWindowResize");

Object.defineProperty(exports, "useWindowSize", {
  enumerable: true,
  get: function get() {
    return useWindowResize_1.useWindowSize;
  }
});

var useWindowScroll_1 = require("./useWindowScroll");

Object.defineProperty(exports, "useWindowScroll", {
  enumerable: true,
  get: function get() {
    return useWindowScroll_1.useWindowScroll;
  }
});